import { Text, Flex } from '@chakra-ui/react';
import { useLocation } from 'react-router';

function ThankYouPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  return (
    <Flex direction="column" alignItems="center" gap={4}>
      <Text textStyle="heading2" textAlign="center">
        Thank you{!token ? ' for your enquiry' : ''}!
      </Text>
      {token ? (
        <>
          <Text textStyle="bodyMedium" lineHeight="160%" textAlign="center">
            Please click the verification link we sent to the email address
            provided. Make sure to check your spam folder if you can't see it in
            your inbox.
          </Text>
        </>
      ) : (
        <Text textStyle="bodyMedium" lineHeight="160%" textAlign="center">
          Our team will reach out to you shortly. If your enquiry is urgent
          please call us on +44 207 933 3157.
        </Text>
      )}
    </Flex>
  );
}

export default ThankYouPage;
